import React, { useReducer } from "react"
import ConfirmationReducer from 'shared/panels/confirmation/state/ConfirmationReducer'
import ConfirmationPanel from 'shared/panels/confirmation/ConfirmationPanel'

export const ConfirmationContext = React.createContext();

const ConfirmationState = ({ children }) => {
  const initialState = {
    data: {},
  }
  const [state, dispatch] = useReducer(ConfirmationReducer, initialState);


  return (
    <ConfirmationContext.Provider
      value={{
        state,
        ...state,
        dispatch,
      }}
    >
      <ConfirmationPanel {...state} />
      {children}
    </ConfirmationContext.Provider>
  )
}

export default ConfirmationState
